<template>
  <page v-model:filter="q" :name="$t('My hosting')" :empty="services.length <= 0" :state="servicesState">
    <template #toolbar-pre>
      <pf-button variant="secondary" @click="settingsModal = true" :title="$t('Impostazioni generali')">
        <template #icon>
          <gear-icon />
        </template>
      </pf-button>
    </template>

    <pf-page-section>
      <pf-data-list>
        <pf-data-list-item v-for="service in filtered" :key="service.dominio" :data-ouia-component-id="`service-${service.dominio}`">
          <pf-data-list-cell>
            {{ service.dominio }}
          </pf-data-list-cell>

          <pf-data-list-cell v-if="service.pannello" no-fill> <circle-nodes-icon /> {{ $t('Web') }} </pf-data-list-cell>
          <pf-data-list-cell v-if="service.pannello || service.posta" no-fill> <envelope-icon /> {{ $t('Email') }} </pf-data-list-cell>
          <pf-data-list-cell v-if="service.pecs" no-fill> <envelope-icon /> {{ $t('PEC') }} </pf-data-list-cell>
          <pf-data-list-cell v-if="service.id_registrazione_dominio" no-fill> <globe-icon /> {{ $t('Dominio') }} </pf-data-list-cell>
          <pf-data-list-cell v-if="service.dns" no-fill> <domain-icon /> {{ $t('DNS') }} </pf-data-list-cell>
          <pf-data-list-cell v-if="service.redirect !== undefined" no-fill> <arrow-icon /> {{ $t('Redirect') }} </pf-data-list-cell>
          <pf-data-list-action>
            <granted-link :to="{ name: 'service_detail', params: { domain: service.dominio } }" type="primary" small>
              {{ $t('Dettagli') }}
            </granted-link>
          </pf-data-list-action>
        </pf-data-list-item>
      </pf-data-list>
    </pf-page-section>
  </page>

  <configuration-form v-if="settingsModal" @cancel="settingsModal = false" @submit="settingsModal = false" />
</template>

<script lang="ts" setup>
import GrantedLink from '@/components/granted-link.vue';
import { ServiceResource } from '@/resources';
import { asyncComputedList } from '@common/asyncComputed';
import { any } from '@common/utils';
import { ref, computed } from 'vue';
import ConfigurationForm from '@/components/configuration-form.vue';
import CircleNodesIcon from '@vue-patternfly/icons/circle-nodes-icon';
import DomainIcon from '@vue-patternfly/icons/domain-icon';
import ArrowIcon from '@vue-patternfly/icons/arrow-icon';
import EnvelopeIcon from '@vue-patternfly/icons/envelope-icon';
import GearIcon from '@vue-patternfly/icons/gear-icon';
import GlobeIcon from '@vue-patternfly/icons/globe-icon';

const { result: services, state: servicesState } = asyncComputedList(() => new ServiceResource().get());

const q = ref('');
const filtered = computed(() => services.value.filter(any(q.value)));
const settingsModal = ref(false);
</script>
